// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"0d4a6ad6","714":"9a2712a9","982":"d3a74c5f"}[chunkId] + ".chunk.css";
};